import type { ReactNode } from 'react';
import styles from './figure-card.module.css';

type FigureCardProps = {
  label: string;
  value: string;
  children?: ReactNode;
};

export const FigureCard = ({ label, value, children }: FigureCardProps) => (
  <section className={styles.figure}>
    <h2 className={styles.figureLabel}>{label}</h2>
    <p className={styles.figureValue}>{value}</p>
    {children}
  </section>
);

type FigureNoteProps = {
  children: ReactNode;
};

export const FigureNote = ({ children }: FigureNoteProps) => (
  <p className={styles.figureNote}>{children}</p>
);
